
import { authProvider } from '../utils/authProvider';

export async function callApi(method: string, url: string, path: string, data?: any) {
    let accountInfo = authProvider.getAccountInfo();
    //console.log("JwtIdToken : " + accountInfo?.jwtIdToken);

    const res = await fetch(`${url}/api${path}`, {
      method,
      headers: {
        Accept: 'application/json',
        Authorization: "Bearer " + accountInfo?.jwtIdToken
      },
      body: JSON.stringify(data)
    })
    return res.json()
  }
  